// @flow
import React from "react";

const ExternalLinkIndicator= ({small, medium}:{small?: boolean, medium?: boolean}) =>{
    let sizeClass = "fa-1_5x"; 
    if(small) {
         sizeClass="fa-0_5x";
     }
     else if(medium) {
         sizeClass="fa-1x";
     }
    return <span className="position-relative">
                    <i className={"fas fa-arrow-up-right-from-square li-pointer mr-2 "+sizeClass} style={{position:"absolute",top: "6px"}}/>
                </span>;
}

export default ExternalLinkIndicator;